import { Component } from 'react';

/**
 * Filet de sécurité global. Capture les erreurs de rendu React pour éviter
 * l'écran blanc (ou l'impression que « l'app se ferme ») et affiche un message
 * lisible avec un bouton pour recharger. Sans cela, toute exception lors du
 * rendu démonte silencieusement l'arbre React.
 */
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Visible dans `adb logcat` (Android) ou la console pour diagnostiquer.
    console.error('Erreur non rattrapée (ErrorBoundary):', error, info?.componentStack);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    if (typeof window !== 'undefined') window.location.assign('/');
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-muted/30 text-center">
          <div className="max-w-sm space-y-4">
            <div className="w-14 h-14 rounded-full bg-rose-100 text-rose-600 flex items-center justify-center mx-auto text-2xl">
              !
            </div>
            <h1 className="text-lg font-semibold">Une erreur est survenue</h1>
            <p className="text-sm text-muted-foreground">
              L'application a rencontré un problème inattendu. Vous pouvez
              recharger pour réessayer.
            </p>
            {this.state.error?.message && (
              <pre className="text-left text-xs bg-muted rounded-lg p-3 overflow-x-auto text-muted-foreground">
                {this.state.error.message}
              </pre>
            )}
            <button
              type="button"
              onClick={this.handleReload}
              className="w-full rounded-xl bg-primary text-primary-foreground py-2.5 text-sm font-medium"
            >
              Recharger l'application
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
